import { Box, Button, Flex, Grid, GridItem, Heading, Popover, PopoverBody, PopoverContent, PopoverTrigger, Text, useDisclosure, Image, } from "@chakra-ui/react";
import MyDiv from "./RecruitmentDashboard.style";
import { useEffect, useState } from "react";
import { CalendarIcon } from "@chakra-ui/icons";
import Calendar from "react-calendar";
import TotalOpening from "../../../assets/images/TotalOpening.svg";
import ActiveCandidates from "../../../assets/images/ActiveCandidates.svg";
import InterviewScheduled from "../../../assets/images/InterviewScheduled.svg";
import OfferReleased from "../../../assets/images/OfferReleased.svg";
import { CandidateStatusCard, DepartmentJobOpening, JobOpeningsCard, UpcomingInterviewsCard, } from "./components";
import { CustomToast } from "../../../components";
import { useFetch } from "../../../hooks/useFetch";

const RecruitmentDashboard = () => {
  const { addToast } = CustomToast();
  const { fetchApi, loading } = useFetch(addToast);
  const [employeeName, setEmployeeName] = useState("");
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [activeTab, setActiveTab] = useState<"jobOpeningsCard" | "upcomingInterviewsCard">("jobOpeningsCard");
  const formatMonthYear = (date: Date) => date.toLocaleString("default", { month: "long", year: "numeric" });
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [dashboardSummary, setDashboardSummary] = useState<any>(null);

  useEffect (() =>{
    const loginData = sessionStorage.getItem('loginData');
    if(loginData){
      const parsedData = JSON.parse(loginData);
      setEmployeeName(parsedData.employeeName);
    }
  },[]);

  const cards = [
    { label: "Total Opening", icon: TotalOpening, count: dashboardSummary?.totalOpenings || 0 },
    { label: "Active Candidates", icon: ActiveCandidates, count: dashboardSummary?.activeCandidates || 0 },
    { label: "Interview Scheduled", icon: InterviewScheduled, count: dashboardSummary?.interviewScheduled || 0 },
    { label: "Offer Released", icon: OfferReleased, count: dashboardSummary?.offerReleased || 0 },
  ];

  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return "Morning";
    else if (hour < 17) return "Afternoon";
    else return "Evening";
  };


  const loadDashboardSummary = async () => {
    const formattedDate = selectedDate.getMonth() + 1;
    const formattedYear = selectedDate.getFullYear();

    const response = await fetchApi("RecruitmentDashboard/DashboardSummary", "GET", "", `selectedDate=${formattedDate}&selectedYear=${formattedYear}`, "");
    if (response) {
      setDashboardSummary(response);
    }
  }

  useEffect(() => {
    loadDashboardSummary();
  }, [selectedDate]);

  return (
    <MyDiv>
      <Box className="page_wrapper">
        <Flex className="page_heading flex_header" justify="space-between">
          <Heading as="h1" className="font-poppins font_dark text_semibold text_3xl">Dashboard</Heading>
          <Popover isOpen={isOpen} onOpen={onOpen} onClose={onClose} placement="bottom-end">
            <PopoverTrigger>
              <Button leftIcon={<CalendarIcon />} padding={3} variant="outline">
                <Text className="font-poppins text_sm text_regular">{formatMonthYear(selectedDate)}</Text>
              </Button>
            </PopoverTrigger>
            <PopoverContent w="auto">
              <PopoverBody p={2} display="flex" justifyContent="center">
                <Calendar
                  value={selectedDate}
                  onChange={(value) => {
                    if (value instanceof Date) {
                      setSelectedDate(value);
                      onClose();
                    }
                  }}
                  view="year"
                  maxDetail="year"
                  maxDate={new Date()}
                />
              </PopoverBody>
            </PopoverContent>
          </Popover>
        </Flex>
        <Text className="font-poppins common_color text_medium text_xl" mt={2}>{`Good ${getGreeting()},  ${employeeName || "User"}`}</Text>
        <>
          <Grid className="grid_container grid_gap_sm" mt={5}>
            {cards.map((card, index) => (
              <GridItem key={index} colSpan={{ base: 12, sm: 6, md: 6, lg: 3 }} className="card_box">
                <Flex align="center">
                  <Image src={card.icon} className="card_icon" alt={card.label} />
                  <Text className="card_label font-poppins text_xl text_medium" pb={5}>{card.label}</Text>
                </Flex>
                <Text className="card_value font-poppins text_5xl text_bold" pl={5}>{card.count}</Text>
              </GridItem>
            ))}

            <GridItem colSpan={6} mt={4}>
              <DepartmentJobOpening data={dashboardSummary?.openingsByDepartment} loading={loading} />
            </GridItem>

            <GridItem colSpan={6} mt={4}>
              <CandidateStatusCard candidateStatusCount={dashboardSummary?.candidateStatusDistribution} loading={loading} />
            </GridItem>
            <GridItem colSpan={3} mt={4}>
              <Box bg="#F1F1F1" p={2} borderRadius="md" w="auto" position="relative">
                <Flex gap={2} w="100%">
                  <Button onClick={() => setActiveTab("jobOpeningsCard")} bg={activeTab === "jobOpeningsCard" ? "white" : "transparent"} p={3}>Job Openings</Button>
                  <Button onClick={() => setActiveTab("upcomingInterviewsCard")} bg={activeTab === "upcomingInterviewsCard" ? "white" : "transparent"} p={3}> Upcoming Interviews </Button>
                </Flex>
              </Box>
            </GridItem>

            <GridItem colSpan={12}>
              <Box bg="white" >
                {activeTab === "jobOpeningsCard" ? (<JobOpeningsCard selectedDate={selectedDate} />) : (<UpcomingInterviewsCard  />)}
              </Box>
            </GridItem>
          </Grid>
        </>
      </Box>
    </MyDiv>
  );
};

export default RecruitmentDashboard;
